__turbopack_context__.v({
  "page": "page-module___5Ws6G__page",
});
